<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 7H21" stroke="#223F53" stroke-width="2" stroke-linecap="round"></path>
    <path d="M3 12H21" stroke="#223F53" stroke-width="2" stroke-linecap="round"></path>
    <path d="M3 17H21" stroke="#223F53" stroke-width="2" stroke-linecap="round"></path>
  </svg>
</template>